
import UIkit from 'uikit'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '../../../lib/models/User'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import CustomerNoteRaw from '@/components/admin/customer/CustomerNoteRaw.vue'

@Component({
  components: {
    BacButton,
    BacInput,
    BacModal,
    CustomerNoteRaw
  }
})
export default class MoreInfosModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  async updateNotes () {
    await this.user.updateNotes()
    UIkit.modal('#more-infos-modal').hide()
    UIkit.notification({
      message: 'Notizen erfolgreich gespeichert',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}

